import { render, staticRenderFns } from "./ModalGerarRepasse.vue?vue&type=template&id=0c73ddad"
import script from "./ModalGerarRepasse.vue?vue&type=script&lang=ts"
export * from "./ModalGerarRepasse.vue?vue&type=script&lang=ts"
import style0 from "./ModalGerarRepasse.vue?vue&type=style&index=0&id=0c73ddad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports